import React from 'react'
import { containerIds } from 'modules/ui'
import { message } from 'antd'
import styled, { keyframes } from 'styled-components'
import FileUpload from 'components/molecules/FileUpload'
import Icon from 'frontend_component/dist/components/atoms/Icon'
export default class InvitationForm extends React.Component {
  constructor(props) {
    super(props)
    this.input = React.createRef()
    this.state = {
      fileName: '',
    }
  }

  onSubmit = async e => {
    e.preventDefault()
    const { actions, company, inviteCompanyEmployee } = this.props

    try {
      const res = await inviteCompanyEmployee({
        companyId: company.id,
        email: this.input.current.value,
      })
      this.input.current.value = ''
      if (res.data.inviteCompanyEmployee.userErrors.length) {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          failureMsg: i18n.t('page.employee.l_00012'),
        })
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            failureMsg: null,
          })
        }, 5000)
      } else {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          successfulMsg: i18n.t('page.employee.l_00013'),
        })
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            successfulMsg: null,
          })
        }, 5000)
      }
    } catch (e) {
      message.warning(i18n.t('error.500.title'))
    } finally {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        mutateLoading: false,
      })
    }
  }

  uploadCSV = async reader => {
    const { actions, company, createCompanyEmployeeInvitationList } = this.props
    try {
      let file = reader.result
      if (document.documentMode && navigator.msSaveOrOpenBlob) {
        // for IE
        // IE で readAsDataURL でエンコードしたときに CSV ファイルタイプが取れないので付け足す
        file = reader.result.replace(/^data:;/, 'data:text/csv;')
      }
      const input = {
        companyId: company.id,
        file: file,
      }
      const res = await createCompanyEmployeeInvitationList(input)
      const userErrors = res.data.createCompanyEmployeeInvitationList.userErrors
      if (userErrors.length) {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          uploadError: true,
          failureMsg: i18n.t('page.employee.l_00012'),
        })
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            failureMsg: null,
          })
        }, 5000)
      } else {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          isSendButton: true,
        })
      }
    } catch (e) {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        uploadError: true,
      })
      message.warning(i18n.t('error.500.title'))
    } finally {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        mutateLoading: false,
      })
    }
  }

  onSelectFile = e => {
    e.preventDefault()
    const { actions } = this.props
    actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
      mutateLoading: true,
      startUpload: true,
      uploadError: false,
      isSendButton: false,
    })
    if (e.target.files.length > 0) {
      this.setState({ fileName: e.target.files[0].name })
      const reader = new FileReader()
      reader.addEventListener(
        'load',
        () => {
          this.uploadCSV(reader)
        },
        false,
      )

      reader.readAsDataURL(e.target.files[0])
    } else {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        mutateLoading: false,
        startUpload: false,
      })
    }
  }

  sendMail = async e => {
    e.preventDefault()
    const { company, bulkInviteCompanyEmployee, actions } = this.props
    try {
      const input = {
        companyId: company.id,
      }
      const res = await bulkInviteCompanyEmployee(input)
      const userErrors = res.data.bulkInviteCompanyEmployee.userErrors
      if (userErrors.length) {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          failureMsg: i18n.t('page.employee.l_00012'),
        })
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            failureMsg: null,
          })
        }, 5000)
      } else {
        actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
          successfulMsg: i18n.t('page.employee.l_00013'),
        })
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            successfulMsg: null,
          })
        }, 5000)
      }
    } catch (e) {
      message.warning(i18n.t('error.500.title'))
    }
  }

  downloadTemplateFile = (e, url, filename = 'template.csv') => {
    // for IE
    if (document.documentMode && navigator.msSaveOrOpenBlob) {
      e.preventDefault()
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url)
      xhr.responseType = 'blob'

      xhr.onloadend = () => {
        if (xhr.status !== 200) return
        window.navigator.msSaveBlob(xhr.response, filename)
      }
      xhr.send()
    }
  }

  render() {
    const { company, config, ui } = this.props
    const downloadUrl = `/files/template.csv`

    return (
      <div className="business-employee__invite">
        <div className="business-employee__invite-method">
          <h2 className="business-employee__invite-title">
            {i18n.t('page.employee.l_00014')}
          </h2>
          <input
            type="text"
            name="email"
            ref={this.input}
            className="business__form business-employee__invite-form"
            id="invite-mail"
            placeholder="taro.spesuma@spacemarket.co.jp"
          />
          <input
            type="button"
            className="button-green business-employee__invite-button"
            onClick={this.onSubmit}
            value={i18n.t('page.employee.l_00029')}
          />
          <p className="business-employee__invite-supplement">
            {i18n.t('page.employee.l_00015')}
          </p>
        </div>

        <div className="business-employee__invite-method business-employee__invite-method-url">
          <h2 className="business-employee__invite-title">
            {i18n.t('page.employee.l_00035')}
          </h2>
          <div className="business-employee__invite-flow">
            <h3>
              <span>1.</span>
              {i18n.t('page.employee.l_00036')}
            </h3>
            <p>
              <a
                href={downloadUrl}
                download="template.csv"
                className="business-employee__linktext"
                onClick={e =>
                  this.downloadTemplateFile(e, downloadUrl, 'template.csv')
                }
              >
                <Icon
                  className="icon-spm-download"
                  positionType="left"
                  padding="0 4px 0 0"
                />
                {i18n.t('page.employee.l_00030')}
              </a>
            </p>
            <h3>
              <span>2.</span>
              {i18n.t('page.employee.l_00031')}
            </h3>
            <p className="business-employee__invite-supplement">
              {i18n.t('page.employee.l_00032')}
              <br />
              <br />
              {i18n.t('page.employee.l_00037')}
            </p>
            <FileUpload
              onSelectFile={this.onSelectFile}
              ui={ui}
              fileName={this.state.fileName}
            />
            {ui.isSendButton && (
              <SubmitButton href="#" onClick={this.sendMail}>
                <Icon
                  className="icon-spm-transmit"
                  positionType="left"
                  padding="0 4px 0 0"
                />
                {i18n.t('page.employee.l_00029')}
              </SubmitButton>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const SubmitButton = styled.a`
  background: #00a273;
  font-weight: bold;
  border: 1px solid #00a273;
  color: #fff;
  padding: 10px 16px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 8px;
  cursor: pointer;
  opacity: 0;
  animation: ${fadeIn} 0.3s;
  animation-fill-mode: forwards;
  &:hover {
    color: #fff;
    background: #60ce52;
    border: 1px solid #60ce52;
  }
`
